import { render, staticRenderFns } from "./CustomPdf.vue?vue&type=template&id=3bab5950&scoped=true&"
import script from "./CustomPdf.vue?vue&type=script&lang=ts&"
export * from "./CustomPdf.vue?vue&type=script&lang=ts&"
import style0 from "./CustomPdf.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CustomPdf.vue?vue&type=style&index=1&id=3bab5950&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bab5950",
  null
  
)

export default component.exports